module.exports = __webpack_public_path__ + "img/891c840a-ccab-4d48-b15b-dd31614c2d48.webp.36b5e8da.jpg";